// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IEditSubscriptionRequest,
  TEditSubscriptionModel,
  IMappers,
  TEditSubscriptionResponse,
  IEditSubscriptionResponse,
  IEditSubscriptionResponseError,
} from './types';

export const defaultConfig: TEditSubscriptionModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'subscriptions',
  pathApi: '/v1/edit-subscription/',
  requestType: 'json',
  responseType: 'json',
} as TEditSubscriptionModel;

export function createEditSubscriptionModel(parameters: IEditSubscriptionRequest): TEditSubscriptionModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IEditSubscriptionOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IEditSubscriptionRequest;
}

export async function fetchEditSubscription<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IEditSubscriptionOptions<TResponse200, TResponse400>): Promise<
  TEditSubscriptionResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createEditSubscriptionModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IEditSubscriptionResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IEditSubscriptionResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TEditSubscriptionResponse;
}
